import {
    Box,
    ControlList,
    RightSidebar,
    useListFilterState,
} from "@bsm/component";
import { useDayOffControlFilterForm } from "../../demand/hooks/useDayOffControlFilterForm";
import moment from "moment";
import { MISSING_DAYOFF_LIST_ID } from "../container/ProjectDayOffMissingContainer";

const DayOffMissingListFilter = (props: DayOffListFilterProps) => {
    const controlFilter = useDayOffControlFilterForm(true);

    const { filter, setFilter } = useListFilterState(MISSING_DAYOFF_LIST_ID);

    const handleFilterChange = (value: Record<string, any>) => {
        setFilter((v: any) => {
            const hasValidValues = Object.values(value).some(val => 
                val !== undefined && 
                val !== null && 
                val !== '' && 
                (!Array.isArray(val) || val.length > 0)
            );
            
            if (!hasValidValues) {
                return v;
            }
            
            return {
                ...v,
                data: {
                    ...v.data,
                    ...resetFilter(),
                    ...cleanFilter(),
                    ...value,
                    ...handleFilterByUsers(value?.employee, filter),
                    ...handleFilterBetweenDateRange(value?.dateRange),
                },
            };
        });
    };

    return (
        <RightSidebar
            className={`right-sidebar-absolute box box-white ${props.open ? "" : "hide"}`}
            onClose={props?.onClose}
        >
            <Box
                title="Filter"
                icon="fa-solid fa-filter"
                className="h-full p-0 shadow-none"
                style={{ paddingTop: '15px'}}
            >
                <ControlList
                    {...controlFilter}
                    value={{
                        ...filter.data,
                        employee: filter.data?.employee?.id_among?.map((item: any) => ({id: item}))
                    }}
                    onChange={handleFilterChange}
                />
            </Box>
        </RightSidebar>
    );
};

export default DayOffMissingListFilter;

type DayOffListFilterProps = {
    open: boolean;
    onClose: () => void;
};

const resetFilter = () => {
    return {
        user: undefined,
        dateBegin_supOrEquals: undefined,
        invitations: undefined,
        dateEnd_inf: undefined,
        dateEnd_infOrEquals: undefined,
    };
};

const cleanFilter = () => {
    return {
        users: undefined,
        dateRange: undefined,
        department: undefined,
    };
};

const handleFilterByUsers = (users?: Array<{ id: number }>, filter?: any) => {
    if (users?.length > 0) {
        return {
            employee: {
                department: filter?.data?.employee?.department,
                id_among: users?.map((u) => u.id),
            },
        };
    }

    return {};
};

const handleFilterBetweenDateRange = (dateRange?: Array<string>) => {
    if (dateRange?.length > 0 && dateRange.every((d) => d)) {
        return {
            dateBegin_supOrEquals: dateRange[0],
            dateEnd_infOrEquals: dateRange[1],
        };
    }

    return {};
};
